import { defaultNotificationOptionsSettingValue } from '../../../../../../backend/config/settings/NotificationOptionsDefaultValue';
import { defaultFeatureFlags } from '../../../../../../backend/config/settings/featureFlags';
import { parseISO } from 'date-fns';
// TODO write unit tests for this function
export function mapToAlertWizardFormData(alert, alertConfig, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const deliveryMethods = alertConfig.availableChannels && alertConfig.availableChannels.length > 0 ? alertConfig.availableChannels : [];
    const channels = (_b = (_a = alert.channels) === null || _a === void 0 ? void 0 : _a.filter((channel) => ['inbox', ...deliveryMethods].includes(channel))) !== null && _b !== void 0 ? _b : [];
    // If Template/Draft does not have mandatory channel set, we forcefully set it here
    if (!type || type === 'template' || type === 'draft') {
        const mandatoryChannels = (alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.notificationOptions) && alertConfig.notificationOptions.mandatoryChannels
            ? alertConfig.notificationOptions.mandatoryChannels
            : defaultNotificationOptionsSettingValue.mandatoryChannels;
        mandatoryChannels.forEach((channel) => {
            if (!channels.includes(channel)) {
                channels.push(channel);
            }
        });
    }
    const features = (alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.features) ? alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.features : defaultFeatureFlags.notifications;
    return {
        id: alert.id,
        channels: channels,
        deliveryOrder: {
            deliveryMode: alert.deliveryMode || 'blast',
            textDelay: getChannelDelay('sms', (_c = alert.settings) === null || _c === void 0 ? void 0 : _c.escalationDelay),
            voiceDelay: getChannelDelay('voice', (_d = alert.settings) === null || _d === void 0 ? void 0 : _d.escalationDelay),
        },
        ownerId: alert.ownerId,
        emailAttachments: alert.emailAttachments ? alert.emailAttachments : undefined,
        recipients: ((_e = alert.additionalData) === null || _e === void 0 ? void 0 : _e.recipients)
            ? filterRecipientsByAlertConfig(JSON.parse(alert.additionalData.recipients), alertConfig)
            : {},
        allowResponse: alert.responseOptions.length > 0,
        responseOptions: alert.responseOptions,
        sendDateTime: alert.sendDateTime ? parseISO(alert.sendDateTime) : undefined, // TODO this is most likely bad, we should not use Date object in form data
        subject: alert.subject,
        sendType: alert.sendDateTime ? 'schedule' : 'immediately',
        type: type || 'draft',
        voiceOptions: {
            repeatTimes: (_f = alert.settings) === null || _f === void 0 ? void 0 : _f.voiceRepeatCount,
            waitTime: (_g = alert.settings) === null || _g === void 0 ? void 0 : _g.voiceRepeatDelay,
        },
        textMessage: alert.textMessage,
        voiceMessage: alert.voiceMessage,
        voiceMessageType: alert.voiceMessageType,
        voiceRecordings: alert.voiceRecordings,
        emailCc: features.emailCc ? alert.emailCc : undefined,
        htmlMessage: alert.htmlMessage,
        messageType: alert.messageType, // TODO
        validityInHours: alert.validityInHours,
        title: alert.title,
        icon: alert.icon,
        color: alert.color,
        pinned: alert.pinned,
        permissions: (_h = alert.permissions) !== null && _h !== void 0 ? _h : [],
        phin: features.showPhin ? !!alert.phin : undefined,
        phinOptions: features.showPhin ? alert.phin : undefined,
        customAlertData: ((_j = alert.additionalData) === null || _j === void 0 ? void 0 : _j.customAlertData) != null ? JSON.parse(alert.additionalData.customAlertData) : undefined,
        followUp: ((_k = alert.additionalData) === null || _k === void 0 ? void 0 : _k.followUp) != null ? JSON.parse(alert.additionalData.followUp) : undefined,
        additionalData: alert.additionalData
            ? Object.fromEntries(Object.entries(alert.additionalData).filter(([key]) => key !== 'recipients' && key !== 'customAlertData' && key !== 'followUp'))
            : undefined,
    };
}
function getChannelDelay(channel, escalationDelay) {
    var _a;
    return escalationDelay ? (_a = escalationDelay.find((delay) => delay.channel === channel)) === null || _a === void 0 ? void 0 : _a.delay : undefined;
}
function filterRecipientsByAlertConfig(recipients, alertConfig) {
    const recipientsData = Object.assign({}, recipients);
    const features = (alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.features) ? alertConfig === null || alertConfig === void 0 ? void 0 : alertConfig.features : defaultFeatureFlags.notifications;
    if (!features.enableExternalRecipients && recipients.external) {
        delete recipientsData.external;
    }
    return recipientsData;
}
